// @ts-ignore
import { type ApiResult } from "@utils/httpClientCore";
import { gaApiCall } from "@utils/httpClientCsrf";
// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { renderJsonWithNumbersAsBigint, parseJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import type * as schema from "@newgenerated/shared/schema";
import { serialize_ContentIdList } from "@newgenerated/shared/serializerDeserializer/ContentIdList";
import { deserialize_ContentIxStatusList } from "@newgenerated/shared/serializerDeserializer/ContentIxStatusList";

export async function getIxStatus(props: { body: schema.ContentIdList }): Promise<ApiResult<schema.ContentIxStatusList>> {
  const path = "/gaapi/content-ix-status";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return serialize_ContentIdList(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  const deserialized = ((value): ParserResult<schema.ContentIxStatusList> => {
    return deserialize_ContentIxStatusList(value);
  })(response.data);
  if (deserialized.success == false) {
    console.warn("could not parse response body");
    return { kind: "error", errorCode: null, errorMessage: "deserialize failed" };
  }
  return { kind: "success", data: deserialized.value };
}
